// extracted by mini-css-extract-plugin
export default {"bgModalGrey":"QrModa_bgModalGrey__wwdVL","bgModal":"QrModa_bgModal__tF4fI","qrImage":"QrModa_qrImage__bz3HS","downloadQrBtn":"QrModa_downloadQrBtn__nAtEv"};